import { oneLine } from 'common-tags';
import 'jquery';
import { cookieBase } from 'server-data/flconfigs';
import _ from 'underscore';
import 'web-animations-js';
import 'css/flux/modules/Callout.less';

var _taggedTemplateLiteral = (function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
});

var _templateObject = _taggedTemplateLiteral(['^(([^<>()\\[\\]\\.,;:\\s@"]+(\\.[^<>()\\[\\]\n    \\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]\n    {1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'], ['^(([^<>()\\\\[\\\\]\\\\\\.,;:\\\\s@"]+(\\\\.[^<>()\\\\[\\\\]\n    \\\\\\.,;:\\\\s@"]+)*)|(".+"))@((\\\\[[0-9]{1,3}\\\\.[0-9]{1,3}\\\\.[0-9]{1,3}\\\\.[0-9]\n    {1,3}])|(([a-zA-Z\\\\-0-9]+\\\\.)+[a-zA-Z]{2,}))$']);

/* AUTO INCREASE LANDING PAGE COUNTER */
function addCommas(nStr) {
  nStr = String(nStr);
  var x = nStr.split('.');
  var x1 = x[0];
  var x2 = x.length > 1 ? '.' + x[1] : '';
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1,$2');
  }
  return x1 + x2;
}

var userCount = void 0;
var userCountSpeed = void 0;
var projectCount = void 0;
var projectCountSpeed = void 0;
var userElements = [];
var projectElements = [];

// Create a new promise to check for the AJAX call to get the site stats info.
var initPromise = new Promise(function (resolve, reject) {
  fetch('/ajax/_general_vars.php', {
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (response) {
    if (response.ok) {
      return response.json();
    }

    var error = new Error(response.statusText);
    error.response = response;
    reject(error);
  }).then(function (json) {
    resolve(json);
  });
});

// Create another promise to check for the incrementer settings to increment
// the site stats periodically.
var incrementerPromise = new Promise(function (resolve, reject) {
  fetch('/ajax/count-24h.php', {
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (response) {
    if (response.ok) {
      return response.json();
    }

    var error = new Error(response.statusText);
    error.response = response;
    reject(error);
  }).then(function (json) {
    resolve(json);
  });
});

// Get both promises and wait until both are finished, then initialise the
// site stats.
Promise.all([initPromise, incrementerPromise]).then(function (values) {
  userCountSpeed = 86400000 / values[1].user_count_24h;
  userCount = parseInt(values[0].user_count, 10);

  projectCountSpeed = 86400000 / values[1].project_count_24h;
  projectCount = parseInt(values[0].project_count, 10);

  updateElements(userElements, userCount, userCountSpeed);
  updateElements(projectElements, projectCount, projectCountSpeed);
}).catch(function (error) {
  throw error;
});

function updateElements(elements, currentCount, speed) {
  var processStatsUpdate = function processStatsUpdate() {
    elements.map(function (element) {
      element.textContent = addCommas(currentCount);
      return element;
    });
    currentCount = parseInt(currentCount, 10) + 1;
  };

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(processStatsUpdate, { timeout: 30000 });
  } else {
    processStatsUpdate();
  }

  setTimeout(function () {
    return updateElements(elements, currentCount, speed);
  }, speed);
}

function updateUserCount(element) {
  userElements.push(element);
}

function updateProjectCount(element) {
  projectElements.push(element);
}

var _classCallCheck = (function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
});

var _createClass = (function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
})();

/**
 * Loads the contents of an SVG file and injects it to where it's being called.
 * In its originality this function is only used with the Underscore templating
 * engine, so it only works if the template is being rendered right after
 * compilation.
 * @param  {String} icon The icon name. Consult with FEDs or the
 * [Pattern Library](https://patternlibrary.freelancer.com)
 *                       for the naming convention of the icon you're using.
 * @return {String}      A temporary placeholder element to be replaced later
 * after the XHR fetches the SVG.
 */

function generateUniqueIdentifier() {
  var identifier = 'uiIcon-' + Math.floor(Math.random() * 1024);
  // Does the passwordless form with that identifier exist? Reroll the
  // dice again to get a new unique one.
  if (document.getElementById(identifier)) {
    return generateUniqueIdentifier();
  }

  return identifier;
}

function uiIcon(icon) {
  // Make a placeholder element to be replaced with the SVG later.
  var identifier = generateUniqueIdentifier();
  var placeholderHTML = '<span id="' + identifier + '"></span>';

  // Fetch the contents of the SVG file we're going to replace it with.
  var placeholderNode = void 0;
  // DO NOT use the SystemJS API without talking to @laurent first! Things
  // might go really bad if you do.
  fetch(SystemJS.normalizeSync('icons/' + icon + '.svg')).then(function (response) {
    if (response.ok) {
      return response.text();
    }

    // Remove the placeholder element if the icon is not found or some server
    // problems happened.
    placeholderNode = document.getElementById('' + identifier);
    if (placeholderNode.parentNode) {
      placeholderNode.parentNode.removeChild(placeholderNode);
    }
    throw new Error();
  }).then(function (html) {
    var replace = function replace() {
      placeholderNode = document.getElementById('' + identifier);
      // Sometimes the templates are rendered but never inserted in the DOM
      // ¯\_(ツ)_/¯
      if (placeholderNode) {
        placeholderNode.outerHTML = html;
      }
    };

    // Replace the placeholder element at the next animation frame if possible
    if ('requestAnimationFrame' in window) {
      requestAnimationFrame(replace);
    } else {
      replace();
    }
    // 404 or something else happened. Don't worry about it.
  }).catch(function () {
    return undefined;
  });

  // While that call's happening return the placeholder element to be injected
  // to the template first.
  return placeholderHTML;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used by `_.defaults` to customize its `_.assignIn` use.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to assign.
 * @param {Object} object The parent object of `objValue`.
 * @returns {*} Returns the value to assign.
 */
function assignInDefaults(objValue, srcValue, key, object) {
  if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
    return srcValue;
  }
  return objValue;
}

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$1.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    object[key] = value;
  }
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a
 * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
 * Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto$2.toString;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array and weak map constructors,
  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length,
 *  else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value)) && !isFunction(value);
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function (object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Built-in value references. */
var Reflect = root.Reflect;

/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */
function iteratorToArray(iterator) {
  var data,
      result = [];

  while (!(data = iterator.next()).done) {
    result.push(data.value);
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Built-in value references. */
var enumerate = Reflect ? Reflect.enumerate : undefined,
    propertyIsEnumerable = objectProto$3.propertyIsEnumerable;

/**
 * The base implementation of `_.keysIn` which doesn't skip the constructor
 * property of prototypes or treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  object = object == null ? object : Object(object);

  var result = [];
  for (var key in object) {
    result.push(key);
  }
  return result;
}

// Fallback for IE < 9 with es6-shim.
if (enumerate && !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf')) {
  baseKeysIn = function baseKeysIn(object) {
    return iteratorToArray(enumerate(object));
  };
}

var baseKeysIn$1 = baseKeysIn;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$4.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$1 = objectProto$4.toString;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$4.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty$2.call(value, 'callee') && (!propertyIsEnumerable$1.call(value, 'callee') || objectToString$1.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/** `Object#toString` result references. */
var stringTag = '[object String]';

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$2 = objectProto$5.toString;

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' || !isArray(value) && isObjectLike(value) && objectToString$2.call(value) == stringTag;
}

/**
 * Creates an array of index keys for `object` values of arrays,
 * `arguments` objects, and strings, otherwise `null` is returned.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array|null} Returns index keys, else `null`.
 */
function indexKeys(object) {
  var length = object ? object.length : undefined;
  if (isLength(length) && (isArray(object) || isString(object) || isArguments(object))) {
    return baseTimes(length, String);
  }
  return null;
}

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$6;

  return value === proto;
}

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$7.hasOwnProperty;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  var index = -1,
      isProto = isPrototype(object),
      props = baseKeysIn$1(object),
      propsLength = props.length,
      indexes = indexKeys(object),
      skipIndexes = !!indexes,
      result = indexes || [],
      length = result.length;

  while (++index < propsLength) {
    var key = props[index];
    if (!(skipIndexes && (key == 'length' || isIndex(key, length))) && !(key == 'constructor' && (isProto || !hasOwnProperty$3.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This method is like `_.assignIn` except that it accepts `customizer`
 * which is invoked to produce the assigned values. If `customizer` returns
 * `undefined`, assignment is handled by the method instead. The `customizer`
 * is invoked with five arguments: (objValue, srcValue, key, object, source).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extendWith
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @see _.assignWith
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   return _.isUndefined(objValue) ? srcValue : objValue;
 * }
 *
 * var defaults = _.partialRight(_.assignInWith, customizer);
 *
 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var assignInWith = createAssigner(function (object, source, srcIndex, customizer) {
  copyObject(source, keysIn(source), object, customizer);
});

/** `Object#toString` result references. */
var errorTag = '[object Error]';

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$3 = objectProto$8.toString;

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object,
 *  else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError(value) {
  if (!isObjectLike(value)) {
    return false;
  }
  return objectToString$3.call(value) == errorTag || typeof value.message == 'string' && typeof value.name == 'string';
}

/**
 * Attempts to invoke `func`, returning either the result or the caught error
 * object. Any additional arguments are provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {Function} func The function to attempt.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {*} Returns the `func` result or error object.
 * @example
 *
 * // Avoid throwing errors for invalid selectors.
 * var elements = _.attempt(function(selector) {
 *   return document.querySelectorAll(selector);
 * }, '>_>');
 *
 * if (_.isError(elements)) {
 *   elements = [];
 * }
 */
var attempt = baseRest(function (func, args) {
  try {
    return apply(func, undefined, args);
  } catch (e) {
    return isError(e) ? e : new Error(e);
  }
});

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function (key) {
    return object[key];
  });
}

/** Used to escape characters for inclusion in compiled string literals. */
var stringEscapes = {
  '\\': '\\',
  "'": "'",
  '\n': 'n',
  '\r': 'r',
  '\u2028': 'u2028',
  '\u2029': 'u2029'
};

/**
 * Used by `_.template` to escape characters for inclusion in compiled string literals.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
function escapeStringChar(chr) {
  return '\\' + stringEscapes[chr];
}

/**
 * Creates a function that invokes `func` with its first argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetPrototype = Object.getPrototypeOf;

/**
 * Gets the `[[Prototype]]` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {null|Object} Returns the `[[Prototype]]`.
 */
var getPrototype = overArg(nativeGetPrototype, Object);

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$9.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
  // that are composed entirely of index properties, return `false` for
  // `hasOwnProperty` checks of them.
  return object != null && (hasOwnProperty$4.call(object, key) || typeof object == 'object' && key in object && getPrototype(object) === null);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = Object.keys;

/**
 * The base implementation of `_.keys` which doesn't skip the constructor
 * property of prototypes or treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
var baseKeys = overArg(nativeKeys, Object);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  var isProto = isPrototype(object);
  if (!(isProto || isArrayLike(object))) {
    return baseKeys(object);
  }
  var indexes = indexKeys(object),
      skipIndexes = !!indexes,
      result = indexes || [],
      length = result.length;

  for (var key in object) {
    if (baseHas(object, key) && !(skipIndexes && (key == 'length' || isIndex(key, length))) && !(isProto && key == 'constructor')) {
      result.push(key);
    }
  }
  return result;
}

/** Used to match template delimiters. */
var reInterpolate = /<%=([\s\S]+?)%>/g;

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function (key) {
    return object == null ? undefined : object[key];
  };
}

/** Used to map characters to HTML entities. */
var htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '`': '&#96;'
};

/**
 * Used by `_.escape` to convert characters to HTML entities.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
var escapeHtmlChar = basePropertyOf(htmlEscapes);

/** Built-in value references. */
var Symbol = root.Symbol;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used for built-in method references. */
var objectProto$10 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$4 = objectProto$10.toString;

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike(value) && objectToString$4.call(value) == symbolTag;
}

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/** Used to match HTML entities and HTML characters. */
var reUnescapedHtml = /[&<>"'`]/g,
    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

/**
 * Converts the characters "&", "<", ">", '"', "'", and "\`" in `string` to
 * their corresponding HTML entities.
 *
 * **Note:** No other characters are escaped. To escape additional
 * characters use a third-party library like [_he_](https://mths.be/he).
 *
 * Though the ">" character is escaped for symmetry, characters like
 * ">" and "/" don't need escaping in HTML and have no special meaning
 * unless they're part of a tag or unquoted attribute value. See
 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
 * (under "semi-related fun fact") for more details.
 *
 * Backticks are escaped because in IE < 9, they can break out of
 * attribute values or HTML comments. See [#59](https://html5sec.org/#59),
 * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
 * [#133](https://html5sec.org/#133) of the
 * [HTML5 Security Cheatsheet](https://html5sec.org/) for more details.
 *
 * When working with HTML you should always
 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
 * XSS vectors.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escape('fred, barney, & pebbles');
 * // => 'fred, barney, &amp; pebbles'
 */
function escape$1(string) {
    string = toString(string);
    return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
}

/** Used to match template delimiters. */
var reEscape = /<%-([\s\S]+?)%>/g;

/** Used to match template delimiters. */
var reEvaluate = /<%([\s\S]+?)%>/g;

/**
 * By default, the template delimiters used by lodash are like those in
 * embedded Ruby (ERB). Change the following template settings to use
 * alternative delimiters.
 *
 * @static
 * @memberOf _
 * @type {Object}
 */
var templateSettings = {

  /**
   * Used to detect `data` property values to be HTML-escaped.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'escape': reEscape,

  /**
   * Used to detect code to be evaluated.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'evaluate': reEvaluate,

  /**
   * Used to detect `data` property values to inject.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'interpolate': reInterpolate,

  /**
   * Used to reference the data object in the template text.
   *
   * @memberOf _.templateSettings
   * @type {string}
   */
  'variable': '',

  /**
   * Used to import variables into the compiled template.
   *
   * @memberOf _.templateSettings
   * @type {Object}
   */
  'imports': {

    /**
     * A reference to the `lodash` function.
     *
     * @memberOf _.templateSettings.imports
     * @type {Function}
     */
    '_': { 'escape': escape$1 }
  }
};

/** Used to match empty string literals in compiled template source. */
var reEmptyStringLeading = /\b__p \+= '';/g,
    reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
    reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

/**
 * Used to match
 * [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components).
 */
var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

/** Used to ensure capturing order of template delimiters. */
var reNoMatch = /($^)/;

/** Used to match unescaped characters in compiled string literals. */
var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

/**
 * Creates a compiled template function that can interpolate data properties
 * in "interpolate" delimiters, HTML-escape interpolated data properties in
 * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
 * properties may be accessed as free variables in the template. If a setting
 * object is given, it takes precedence over `_.templateSettings` values.
 *
 * **Note:** In the development build `_.template` utilizes
 * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
 * for easier debugging.
 *
 * For more information on precompiling templates see
 * [lodash's custom builds documentation](https://lodash.com/custom-builds).
 *
 * For more information on Chrome extension sandboxes see
 * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The template string.
 * @param {Object} [options={}] The options object.
 * @param {RegExp} [options.escape=_.templateSettings.escape]
 *  The HTML "escape" delimiter.
 * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
 *  The "evaluate" delimiter.
 * @param {Object} [options.imports=_.templateSettings.imports]
 *  An object to import into the template as free variables.
 * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
 *  The "interpolate" delimiter.
 * @param {string} [options.sourceURL='templateSources[n]']
 *  The sourceURL of the compiled template.
 * @param {string} [options.variable='obj']
 *  The data object variable name.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the compiled template function.
 * @example
 *
 * // Use the "interpolate" delimiter to create a compiled template.
 * var compiled = _.template('hello <%= user %>!');
 * compiled({ 'user': 'fred' });
 * // => 'hello fred!'
 *
 * // Use the HTML "escape" delimiter to escape data property values.
 * var compiled = _.template('<b><%- value %></b>');
 * compiled({ 'value': '<script>' });
 * // => '<b>&lt;script&gt;</b>'
 *
 * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
 * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the internal `print` function in "evaluate" delimiters.
 * var compiled = _.template('<% print("hello " + user); %>!');
 * compiled({ 'user': 'barney' });
 * // => 'hello barney!'
 *
 * // Use the ES delimiter as an alternative to the default "interpolate" delimiter.
 * var compiled = _.template('hello ${ user }!');
 * compiled({ 'user': 'pebbles' });
 * // => 'hello pebbles!'
 *
 * // Use backslashes to treat delimiters as plain text.
 * var compiled = _.template('<%= "\\<%- value %\\>" %>');
 * compiled({ 'value': 'ignored' });
 * // => '<%- value %>'
 *
 * // Use the `imports` option to import `jQuery` as `jq`.
 * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
 * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the `sourceURL` option to specify a custom sourceURL for the template.
 * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
 * compiled(data);
 * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
 *
 * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
 * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
 * compiled.source;
 * // => function(data) {
 * //   var __t, __p = '';
 * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
 * //   return __p;
 * // }
 *
 * // Use custom template delimiters.
 * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
 * var compiled = _.template('hello {{ user }}!');
 * compiled({ 'user': 'mustache' });
 * // => 'hello mustache!'
 *
 * // Use the `source` property to inline compiled templates for meaningful
 * // line numbers in error messages and stack traces.
 * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
 *   var JST = {\
 *     "main": ' + _.template(mainText).source + '\
 *   };\
 * ');
 */
function template(string, options, guard) {
  // Based on John Resig's `tmpl` implementation
  // (http://ejohn.org/blog/javascript-micro-templating/)
  // and Laura Doktorova's doT.js (https://github.com/olado/doT).
  var settings = templateSettings.imports._.templateSettings || templateSettings;

  if (guard && isIterateeCall(string, options, guard)) {
    options = undefined;
  }
  string = toString(string);
  options = assignInWith({}, options, settings, assignInDefaults);

  var imports = assignInWith({}, options.imports, settings.imports, assignInDefaults),
      importsKeys = keys(imports),
      importsValues = baseValues(imports, importsKeys);

  var isEscaping,
      isEvaluating,
      index = 0,
      interpolate = options.interpolate || reNoMatch,
      source = "__p += '";

  // Compile the regexp to match each delimiter.
  var reDelimiters = RegExp((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');

  // Use a sourceURL for easier debugging.
  var sourceURL = 'sourceURL' in options ? '//# sourceURL=' + options.sourceURL + '\n' : '';

  string.replace(reDelimiters, function (match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
    interpolateValue || (interpolateValue = esTemplateValue);

    // Escape characters that can't be included in string literals.
    source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

    // Replace delimiters with snippets.
    if (escapeValue) {
      isEscaping = true;
      source += "' +\n__e(" + escapeValue + ") +\n'";
    }
    if (evaluateValue) {
      isEvaluating = true;
      source += "';\n" + evaluateValue + ";\n__p += '";
    }
    if (interpolateValue) {
      source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
    }
    index = offset + match.length;

    // The JS engine embedded in Adobe products needs `match` returned in
    // order to produce the correct `offset` value.
    return match;
  });

  source += "';\n";

  // If `variable` is not specified wrap a with-statement around the generated
  // code to add the data object to the top of the scope chain.
  var variable = options.variable;
  if (!variable) {
    source = 'with (obj) {\n' + source + '\n}\n';
  }
  // Cleanup code by stripping empty strings.
  source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');

  // Frame code as the function body.
  source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ', __j = Array.prototype.join;\n' + "function print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';

  var result = attempt(function () {
    return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
  });

  // Provide the compiled function's source by its `toString` method or
  // the `source` property as a convenience for inlining compiled templates.
  result.source = source;
  if (isError(result)) {
    throw result;
  }
  return result;
}

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/** Used for built-in method references. */
var objectProto$11 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$5 = objectProto$11.toString;

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' || isObjectLike(value) && objectToString$5.call(value) == numberTag;
}

function getCookie(cName) {
  var cookies = document.cookie;
  if (cookies.length > 0) {
    var cStart = cookies.indexOf(cName + '=');
    if (cStart != -1) {
      cStart = cStart + cName.length + 1;
      var cEnd = cookies.indexOf(';', cStart);
      if (cEnd == -1) cEnd = cookies.length;
      return cookies.substring(cStart, cEnd);
    }
  }
  return '';
}

var TRANSLATE_MODE_COOKIE = cookieBase + '_TRANSLATE_MODE';

var isTranslateModeEnabled = function isTranslateModeEnabled() {
  return getCookie(TRANSLATE_MODE_COOKIE) === '1';
};

var getTokenizedMessage = function getTokenizedMessage(id, message) {
  return isTranslateModeEnabled() ? '~=[' + id + '|^|' + message + ']=~' : message;
};

var translate = function translate(first) {
  for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  switch (true) {
    case isString(first):
      {
        var text = first;
        var vars = rest[0];
        if (typeof vars === 'undefined' || !vars) {
          return text;
        }
        var result = template(text, {
          evaluate: /<\[([\s\S]+?)\]>/g,
          interpolate: /<\[=([\s\S]+?)\]>/g,
          escape: /<\[-([\s\S]+?)\]>/g
        })(vars);
        result = template(result)(vars);
        return result;
      }
    case isArray(first):
      {
        return oneLine([translate.raw.apply(translate, [first].concat(rest))]);
      }
    case isNumber(first):
      {
        var _ret = function () {
          var sourceTextId = first;
          return {
            v: function v() {
              return getTokenizedMessage(sourceTextId, translate.apply(undefined, arguments));
            }
          };
        }();

        if (typeof _ret === "object") return _ret.v;
      }
    default:
      {
        throw new TypeError('Invalid argument types');
      }
  }
};

translate.raw = function rawT(literals) {
  for (var _len2 = arguments.length, placeholders = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    placeholders[_key2 - 1] = arguments[_key2];
  }

  return literals.raw.reduce(function (str, current, index) {
    var temp = str + current;
    if (index < placeholders.length) {
      temp += placeholders[index].toString();
    }
    return temp;
  }, '');
};

var template$1 = "<div id=\"callout-<%- id %>\" class=\"Callout <%- options.extraClass %>\">\n        <div id=\"callout-<%- id %>-arrow\" class=\"Callout-arrow\" role=\"presentation\"></div>\n    <% if (options.closeButton) {%>\n    <button id=\"callout-<%- id %>-close\" class=\"Callout-close\">\n      <span class=\"Callout-close-icon Icon Icon--small\">\n        <%= uiIcon('ui-close') %>\n      </span>\n    </button>\n    <% } %>\n    <% if (options.title) { %>\n        <p class=\"Callout-title\"><%- options.title %></p>\n    <% } %>\n    <div class=\"Callout-content\">\n        <% if (options.richContent) { %>\n            <%= options.content %>\n        <% } else { %>\n            <%- options.content %>\n        <% } %>\n    </div>\n</div>\n";

var PLACEMENT = {
  TOP: 'top',
  BOTTOM: 'bottom',
  LEFT: 'left',
  RIGHT: 'right',
  BOTTOM_LEFT: 'bottom-left',
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  BOTTOM_RIGHT: 'bottom-right'
};

var Callout = function () {
  /**
   * Constructs the callout.
   * @param  {Node}          targetEl             The target element in the DOM
   * to set as the trigger of the Callout.
   * @param  {Object}        [options={}]         Options to change the
   * behavior of the Callout. All these can also be set as data attributes of
   * the target element.
   * @param  {String}        options.title        The title of the Callout.
   * @param  {String}        options.content      The content of the Callout.
   * Can be a normal text or rich HTML content with options.richContent set to
   * true.
   * @param  {Boolean}       options.richContent  Set the Callout to have rich,
   * HTML markup in the content.
   * @param  {Boolean}       options.hoverable    Make the callout toggleable
   * by hovering. Defaults to false.
   * @param  {Boolean}       options.noClick      Disable click event of
   * the callout. Defaults to false.
   * @param  {Int}           hoverDelayOut        Time (in milliseconds) to
   * take for the callout to fade out when not on hover. Defaults to 0 (will
   * disable this feature).
   * @param  {String}        options.placement    The position of which the
   * callout is shown relative to the caller element. Defaults to bottom
   * placement.
   * @param  {Boolean}       options.closeButton  Enables the close button.
   * Defaults to true.
   * @param  {String[]}      options.extraClass   Extra classes to set on the
   * Callout. To use as data attributes just set as a space-separated string
   * instead.
   * @param {Boolean}        options.outsideClick Enables outside click
   * dismissal. Defaults to true.
   * @param {function}       options.onShow       Set a function to be called
   * each time the callout is shown. The function will be given a Callout
   * instance as the first argument.
   * @param {function}       options.onHide       Set a function to be called
   * each time the callout is hidden. The function will be given a Callout
   * instance as the first argument.
   * @return {Callout}                            The Callout instance.
   */
  function Callout(targetEl) {
    var _this = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Callout);

    if (!targetEl) {
      throw new TypeError('Element is not a valid DOM element.');
    }

    if (!targetEl.id) {
      throw new TypeError('Element needs to have an ID.');
    }

    this.targetEl = targetEl;

    // Start parsing options.
    this.options = {};

    this.options.title = this._parseOption('title', options);
    this.options.content = this._parseOption('content', options, '');
    this.options.richContent = this._parseOption('richContent', options, false, false);
    this.options.placement = this._parseOption('placement', options, PLACEMENT.BOTTOM);
    this.options.hoverable = this._parseOption('hoverable', options, false);
    this.options.noClick = this._parseOption('noClick', options, false);
    this.options.hoverDelayOut = this._parseOption('hoverDelayOut', options, 0);
    this.options.showOnload = this._parseOption('showOnload', options, false);
    this.options.closeButton = true;
    var closeButtonAttr = this.targetEl.getAttribute('data-closeButton');
    if (closeButtonAttr !== null) {
      this.options.closeButton = closeButtonAttr !== 'false';
    }
    if (options.closeButton !== undefined) {
      this.options.closeButton = options.closeButton;
    }
    if (Array.isArray(options.extraClass)) {
      // Convert array of classes to space-separated string.
      this.options.extraClass = options.extraClass.join(' ');
    } else if (typeof options.extraClass === 'string') {
      this.options.extraClass = options.extraClass;
    }
    this.options.extraClass = this._parseOption('extraClass', this.options, '', false);

    this.options.outsideClick = this._parseOption('outsideClick', options, true);

    this.options.onShow = this._parseOption('onShow', options, function () {});

    this.options.onHide = this._parseOption('onHide', options, function () {});
    // In order to detect closing callout from the outside we attach two
    // events (body and callout) when shown and use cancelCloseSignal to
    // signal from the callout click event if the click occurs in the callout
    // to cancel closing it.
    this.cancelCloseSignal = false;

    // Inject the callout before the </body>
    document.body.insertAdjacentHTML('beforeend', this._createFromTemplate({
      id: this.targetEl.id,
      options: this.options
    }));

    // Get the injected callout DOM
    this.element = document.getElementById('callout-' + this.targetEl.id);
    this.element.isActive = false;
    if (this.options.closeButton) {
      this.element.closeButton = document.getElementById('callout-' + this.targetEl.id + '-close');
    }
    this.element.arrow = document.getElementById('callout-' + this.targetEl.id + '-arrow');

    // Add event listeners
    this.eventListeners = {
      elementHoverIn: function elementHoverIn() {
        if (_this.options.hoverDelayOut) {
          clearTimeout(_this._delayOutTimeout);
        }
      },
      elementHoverOut: function elementHoverOut() {
        if (_this.options.hoverDelayOut) {
          _this._delayOut(_this.options.hoverDelayOut);
        }
      },
      targetElClick: function targetElClick() {
        return _this.toggle();
      },
      closeButtonClick: function closeButtonClick() {
        return _this.hide();
      },
      targetElHoverIn: function targetElHoverIn() {
        // Only trigger a show if the callout is not active/visible
        if (!_this.element.isActive) {
          _this.show();
        }

        // Only clear timeout if hoverable and has hoverDelayOut
        if (_this.options.hoverable && _this.options.hoverDelayOut) {
          clearTimeout(_this._delayOutTimeout);
        }
      },
      targetElHoverOut: function targetElHoverOut() {
        // Only set timeout if hoverable and has hoverDelayOut otherwise hide
        // immediately.
        if (_this.options.hoverable && _this.options.hoverDelayOut) {
          _this._delayOut(_this.options.hoverDelayOut);
        } else {
          _this.hide();
        }
      },
      viewportResize: function viewportResize() {
        return _this.recalculatePosition();
      },
      // Outside click listeners that interact with each other
      outsideClickBody: function outsideClickBody() {
        if (!_this.cancelCloseSignal) {
          _this.hide();
        }
        _this.cancelCloseSignal = false;
      },
      outsideClickCallout: function outsideClickCallout() {
        _this.cancelCloseSignal = true;
      }
    };

    if (!this.options.noClick) {
      this.targetEl.addEventListener('click', this.eventListeners.targetElClick);
    }

    if (this.options.closeButton) {
      this.element.closeButton.addEventListener('click', this.eventListeners.closeButtonClick);
    }

    if (this.options.hoverable) {
      this.targetEl.addEventListener('mouseenter', this.eventListeners.targetElHoverIn);
      this.targetEl.addEventListener('mouseleave', this.eventListeners.targetElHoverOut);
      this.element.addEventListener('mouseenter', this.eventListeners.elementHoverIn);
      this.element.addEventListener('mouseleave', this.eventListeners.elementHoverOut);
    }

    if (this.options.showOnload) {
      this.show();
    }

    // Set up animation with the Web Animation API
    this.animationPlayer = null;

    // Set the position of the callout for stylings to communicate with the
    // right CSS properties.
    this.setPlacement(this.options.placement);

    return this;
  }

  /**
   * Hide the callout after the given delay
   * @param  {Int}  delay  Time delay in milliseconds before
   *                       hiding the callout.
   */

  _createClass(Callout, [{
    key: '_delayOut',
    value: function _delayOut(delay) {
      var _this2 = this;

      this._delayOutTimeout = setTimeout(function () {
        _this2.hide();
      }, delay);
    }

    /**
     * Parse the option from the options parameter passed, then the data
     * attribute set in the target element.
     * @param  {String}  name                  The name of the option.
     * @param  {Object}  options               Options Object from the
     *                                         constructor.
     * @param  {*}       [defaultValue=null]   The default value if parsing
     *                                         options and the data attribute
     *                                         fails.
     * @param  {Boolean} [dataAttributes=true] Check data attributes with the
     *                                         template of [data-{name}] for a
     *                                         fallback value if options don't
     *                                         have the value.
     * @return {*}                             The parsed option.
     */

  }, {
    key: '_parseOption',
    value: function _parseOption(name, options) {
      var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var dataAttributes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

      if (name in options) {
        return options[name];
      }
      var attr = this.targetEl.getAttribute('data-' + name);
      if (dataAttributes === true && attr != null) {
        return attr;
      }
      return defaultValue;
    }

    /**
     * Creates the callout from the template.
     * @param  {Object} data An Object containing the data needed by the
     *                       template.
     * @return {String}      The compiled template in HTML in string.
     */

  }, {
    key: '_createFromTemplate',
    value: function _createFromTemplate(data) {
      var compiledTemplate = _.template(template$1);
      // Add uiIcon and translation's T_ in.
      data.uiIcon = uiIcon;
      data.T_ = translate;
      return compiledTemplate(data);
    }

    /**
     * Sets the placement information to the Callout so CSS can take over and
     * position things like where the arrow is pointing to.
     * @param {String} placement  The placement of the Callout relative to the
     *                            callout element. Defaults to
     *                            this.options.placement.
     */

  }, {
    key: 'setPlacement',
    value: function setPlacement() {
      var placement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.placement;

      this.element.setAttribute('data-placement', placement);
    }

    /**
     * Recalculates the position of the callout relative to the element.
     * @param  {String} placement The placement of the callout.
     * @return {Promise}          A promise resolving to when the position is set
     *                            on the next animation frame with the new top
     *                            and left position in an Object.
     */

  }, {
    key: 'recalculatePosition',
    value: function recalculatePosition() {
      var _this3 = this;

      var placement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.placement;

      // Set the placement in case this method is called with a placement override
      // (for example if the Callout is positioned at the bottom and it will
      // overflow from the bottom of the document).
      this.setPlacement(placement);
      // Get the positions and dimensions of the Callout, target element and the
      // document body. Always batch this so layout thrashing doesn't happen.
      var boundingClientRect = this.targetEl.getBoundingClientRect();
      var elementWidth = boundingClientRect.width;
      var elementHeight = boundingClientRect.height;
      var calloutBoundingClientRect = this.element.getBoundingClientRect();
      var calloutWidth = calloutBoundingClientRect.width;
      var calloutHeight = calloutBoundingClientRect.height;
      // IE is such a bad browser. document.documentElement is used for IE
      // compatibility.
      var bodyTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;
      var bodyLeft = document.documentElement && document.documentElement.scrollLeft || document.body.scrollLeft;
      var bodyWidth = document.body.clientWidth;
      var bodyHeight = document.body.clientHeight;

      // Now calculate the positions to be set to the Callout element.
      // Find the location of the target element relative to the document first.
      var top = boundingClientRect.top + bodyTop;
      var left = boundingClientRect.left + bodyLeft;

      if (placement === PLACEMENT.BOTTOM || placement === PLACEMENT.BOTTOM_LEFT || placement === PLACEMENT.BOTTOM_RIGHT) {
        top = top + elementHeight + 20;
        // Recalculate the placement as a top placement if it overflows from
        // the bottom of the document. Disable this though if the new position
        // also overflows.
        if (top + calloutHeight > bodyHeight && placement === this.options.placement) {
          return this.recalculatePosition(PLACEMENT.TOP);
        }
      } else if (placement === PLACEMENT.TOP || placement === PLACEMENT.TOP_LEFT || placement === PLACEMENT.TOP_RIGHT) {
        top = top - calloutHeight - 20;
        // Recalculate the placement as a bottom placement if it overflows from
        // the top of the document. Disable this though if the new position
        // also overflows.
        if (top < 0 && placement === this.options.placement) {
          return this.recalculatePosition(PLACEMENT.BOTTOM);
        }
      } else {
        // This calculation works for PLACEMENT.LEFT and PLACEMENT.RIGHT.
        top = Math.max(Math.min(top + elementHeight / 2 - calloutHeight / 2, bodyHeight - calloutHeight - 20), 20);
      }

      if (placement === PLACEMENT.LEFT) {
        left = left - calloutWidth - 20;
        // Recalculate the placement as a bottom placement if it overflows from
        // the left of the document. Disable this though if the new position
        // also overflows.
        if (left < 0 && placement === this.options.placement) {
          return this.recalculatePosition(PLACEMENT.BOTTOM);
        }
      } else if (placement === PLACEMENT.RIGHT) {
        left = left + elementWidth + 20;
        // Recalculate the placement as a bottom placement if it overflows from
        // the right of the document. Disable this though if the new position
        // also overflows.
        if (left + calloutWidth > bodyWidth && placement === this.options.placement) {
          return this.recalculatePosition(PLACEMENT.BOTTOM);
        }
      } else if (placement === PLACEMENT.BOTTOM_LEFT || placement === PLACEMENT.TOP_LEFT) ; else if (placement === PLACEMENT.BOTTOM_RIGHT || placement === PLACEMENT.TOP_RIGHT) {
        // Set the callout at the right side of the target element.
        left = Math.min(
        // Between setting it in the right side of the target element or setting
        // it at the end of the page
        left + elementWidth - calloutWidth, bodyWidth - calloutWidth - 20);
      } else {
        // This calculation works for PLACEMENT.TOP and PLACEMENT.BOTTOM.
        left = Math.max(Math.min(
        // Between setting it in the middle of the target element or setting
        // it at the end of the page
        left + elementWidth / 2 - calloutWidth / 2, bodyWidth - calloutWidth - 20), 20);
      }

      // Now calculate the arrow position
      // Note that [x]_LEFT and [x]_RIGHT arrow positions are predefined
      // in CSS instead.
      var arrowTop = 0;
      var arrowLeft = 0;

      if (placement === PLACEMENT.TOP || placement === PLACEMENT.BOTTOM) {
        arrowLeft = boundingClientRect.left + bodyLeft + elementWidth / 2 - left;
      } else if (placement === PLACEMENT.LEFT || placement === PLACEMENT.RIGHT) {
        arrowTop = boundingClientRect.top + bodyTop + elementHeight / 2 - top;
      }

      return new Promise(function (resolve) {
        // Set the new positions on the next animation frame.
        var animate = function animate() {
          _this3.element.style.top = top + 'px';
          _this3.element.style.left = left + 'px';

          if (arrowTop) {
            _this3.element.arrow.style.top = arrowTop + 'px';
          } else {
            _this3.element.arrow.style.top = null;
          }
          if (arrowLeft) {
            _this3.element.arrow.style.left = arrowLeft + 'px';
          } else {
            _this3.element.arrow.style.left = null;
          }

          resolve({
            top: top,
            left: left
          });
        };

        if ('requestAnimationFrame' in window) {
          window.requestAnimationFrame(animate);
        } else {
          animate();
        }
      });
    }

    /**
     * Sets up the callout opening and closing animation with the Web Animation
     * API
     * @param  {Boolean} playOpen  Sets the animation to play the opening
     *                             animation first. Defaults to true.
     */

  }, {
    key: '_setupAnimationAndPlay',
    value: function _setupAnimationAndPlay() {
      var playOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.animationPlayer = this.element.animate([{
        opacity: playOpen ? 0 : 1
      }, {
        opacity: playOpen ? 1 : 0
      }], {
        duration: 300,
        fill: 'forwards'
      });
    }

    /**
     * Toggles the callout to open or close.
     * @return {Promise} Resolves to the callout finished being shown or hidden
     *                   without any interruption, or rejects on interruption,
     *                   both returning the animation event.
     */

  }, {
    key: 'toggle',
    value: function toggle() {
      return this.element.isActive ? this.hide() : this.show();
    }

    /**
     * Shows the callout
     * @return {Promise} Resolves to the callout finished being shown without any
     *                   interruption, or rejects on interruption, both returning
     *                   the animation event.
     */

  }, {
    key: 'show',
    value: function show() {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        _this4.element.classList.add('is-Callout-active');
        // Recalculate the position then show when it finishes.
        _this4.recalculatePosition().then(function () {
          _this4.element.isActive = true;
          // Animate the show transition with Web Animations API on an animation
          // frame.
          var animate = function animate() {
            // Animate using the existing player if there's any
            if (_this4.animationPlayer) {
              _this4.animationPlayer.playbackRate = 1;
              _this4.animationPlayer.play();
            } else {
              _this4._setupAnimationAndPlay();
            }

            _this4.animationPlayer.onfinish = function (event) {
              _this4.animationPlayer.onfinish = null;
              resolve(event);
            };
            _this4.animationPlayer.oncancel = function (event) {
              _this4.animationPlayer.oncancel = null;
              reject(event);
            };
          };

          if ('requestAnimationFrame' in window) {
            window.requestAnimationFrame(animate);
          } else {
            animate();
          }

          // Add the resize event when it's shown
          window.addEventListener('resize', _this4.eventListeners.viewportResize);

          // Add the outside click event when it's shown if the option is enabled.
          if (_this4.options.outsideClick) {
            _this4.element.addEventListener('click', _this4.eventListeners.outsideClickCallout);
            document.body.addEventListener('click', _this4.eventListeners.outsideClickBody);
          }

          _this4.options.onShow(_this4);
        });
      });
    }

    /**
     * Hides the callout.
     * @return {Promise} Resolves to the callout finished being hidden without any
     *                   interruption, or rejects on interruption, both returning
     *                   the animation event.
     */

  }, {
    key: 'hide',
    value: function hide() {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        _this5.element.isActive = false;
        // Animate the hide transition with Web Animations API on an animation
        // frame.
        var animate = function animate() {
          // Animate using the existing player if there's any
          if (_this5.animationPlayer) {
            _this5.animationPlayer.playbackRate = -1;
            _this5.animationPlayer.play();
          } else {
            _this5._setupAnimationAndPlay(false);
          }

          _this5.animationPlayer.onfinish = function (event) {
            _this5.element.classList.remove('is-Callout-active');
            _this5.animationPlayer.onfinish = null;
            resolve(event);
          };
          _this5.animationPlayer.oncancel = function (event) {
            _this5.animationPlayer.oncancel = null;
            reject(event);
          };
        };

        if ('requestAnimationFrame' in window) {
          window.requestAnimationFrame(animate);
        } else {
          animate();
        }

        // Remove the resize event
        window.removeEventListener('resize', _this5.recalculatePosition.bind(_this5));

        // Remove the outside click event when it's shown if the option is enabled
        if (_this5.options.outsideClick) {
          _this5.element.removeEventListener('click', _this5.eventListeners.outsideClickCallout);
          document.body.removeEventListener('click', _this5.eventListeners.outsideClick);
        }
        _this5.options.onHide(_this5);
      });
    }

    /**
     * Removes the callout entirely from the document.
     */

  }, {
    key: 'remove',
    value: function remove() {
      document.body.removeChild(this.element);

      // Remove all event listeners related to the Callout.
      this.targetEl.removeEventListener('click', this.eventListeners.targetElClick);
      window.removeEventListener('resize', this.eventListeners.viewportResize);
      this.targetEl.removeEventListener('mouseenter', this.eventListeners.targetElHoverIn);
      this.targetEl.removeEventListener('mouseleave', this.eventListeners.targetElHoverOut);
    }
  }]);

  return Callout;
}();

// Make the callout for the site stats total projects explanation
var triggerEl = document.getElementById('posted-listings');
new Callout(triggerEl);

// Set the new registered users and total jobs posted count
var registeredUsersCount = document.getElementById('footerRegisteredUsersCount');
var totalJobsPostedCount = document.getElementById('footerTotalJobsPostedCount');

updateUserCount(registeredUsersCount);
updateProjectCount(totalJobsPostedCount);
